import React, { PropsWithChildren, FC, useState } from "react";

import {
    Icon,
    MultiSelectCard,
    OnboardingAside,
    OnboardingContent,
    OptionItem,
    PrimaryAlternateControl,
} from "@xapp/components";

import { OnboardingProps } from "../../models";

export interface IntentQuestionStepProps {
    /**
     * Optional aside content
     */
    aside?: React.ReactNode;
    /**
     * Props for building the AI agent
     */
    initialProps?: OnboardingProps;
    /**
     * Optional style applied to the root div
     */
    style?: React.CSSProperties;
    /**
     * Optional class name to apply to the root div
     */
    className?: string;
    /**
     *
     * @param props
     * @returns
     */
    onNext: (props: OnboardingProps) => void;
}

export const IntentQuestionStep: FC<PropsWithChildren<IntentQuestionStepProps>> = (props) => {
    const { aside, initialProps, onNext, style, className } = props;

    const [selected, setSelected] = useState<string[]>([]);

    const intentOptions: OptionItem[] = [
        {
            id: "book_online",
            title: "Enable Google Book Online",
            subtitle: "Allow customers to book you directly from Google Search and Maps",
            icon: <Icon value="contact_page" />,
        },

        {
            id: "booking_link",
            title: "Provide a better way for customers to book you",
            subtitle: "Through your Angi auto-responses, Facebook, or website and more!",
            icon: <Icon value="calendar_month" />,
        },
        {
            id: "chat",
            title: "Setup AI powered chat for your website",
            subtitle: "Answer questions from prospects and capture leads 24/7",
            icon: <Icon value="forum" />,
        },
        {
            id: "explore",
            title: "Just exploring right now",
            subtitle: "I want to explore everything to see what you can do",
            icon: <Icon value="public" />,
        },
    ];

    const handleNext = () => {
        const props: OnboardingProps = {
            ...initialProps,
            beta: {
                ...initialProps?.beta,
                onboarding: {
                    ...initialProps?.beta?.onboarding,
                    intent: selected,
                },
            },
        };

        onNext(props);
    };

    return (
        <>
            {aside && <OnboardingAside>{aside}</OnboardingAside>}

            <OnboardingContent style={{ ...style }} className={className}>
                <h2 style={{ marginTop: 0 }}>What can we help you with today?</h2>
                <small>Select all that apply, we will use this to focus the setup.</small>
                <div style={{ marginTop: "10px" }}>
                    <MultiSelectCard options={intentOptions} selected={selected} onChange={setSelected} />
                </div>
                <PrimaryAlternateControl
                    labels={{ primary: "Continue" }}
                    disabled={{ primary: selected.length === 0 }}
                    onPrimary={handleNext}
                />
            </OnboardingContent>
        </>
    );
};
